"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const HelperUtils_1 = require("utils/HelperUtils");
const CustomInnerIcon_1 = __importDefault(require("components/design-system/CustomInnerIcon"));
const Divider_1 = __importDefault(require("components/design-system/Divider"));
const TooltipPortal_1 = __importDefault(require("components/shared/Tooltips/TooltipPortal"));
const ProgressItem = ({ iconName, iconText, name, active, disabled, onClick, isLast, dataCy, isChecked }) => {
    const [portalData, setPortalData] = (0, react_1.useState)({});
    const [isEllipsis, setIsEllipsis] = (0, react_1.useState)(false);
    const [isTooltipShown, setIsTooltipShown] = (0, react_1.useState)(false);
    const color = active || isChecked ? `var(--base-600)` : `var(--n-600)`;
    const setPortal = (name) => {
        const element = document.getElementById(`track-${name}`);
        if (isEllipsis) {
            setIsTooltipShown(true);
            setPortalData({
                name: name,
                noWrap: true,
                ...(element && {
                    left: element.getBoundingClientRect().right + 8 + 'px',
                    top: element.getBoundingClientRect().top + 'px'
                })
            });
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isEllipsis && !(0, isEmpty_1.default)(portalData) && (react_1.default.createElement(TooltipPortal_1.default, { show: isTooltipShown, portalData: portalData, portalId: 'shared-tooltip' })),
        react_1.default.createElement("div", { id: `track-${name}`, className: `flex items-center px-[24px] relative ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'} ${!isLast && 'mb-[24px]'}`, 
            // Why need timeout?
            // on input score which answers sent after onBlur
            // we need to ensure the onBlur is fired before changing track
            onMouseDown: () => !disabled && setTimeout(() => onClick(), 100), onMouseOver: () => setPortal(name), onMouseOut: () => setIsTooltipShown(false), "data-cy": dataCy },
            react_1.default.createElement(CustomInnerIcon_1.default, { backgroundColor: color, borderColor: color, iconName: isChecked ? 'icon-check' : iconName, iconText: iconText }),
            react_1.default.createElement("span", { className: `ml-[16px] typography-h400 px-[0px] py-[0px] w-[168px] overflow-hidden truncate ${isChecked ? 'text-base-600' : ''}`, ref: (ref) => setIsEllipsis((ref?.offsetWidth || 0) < (ref?.scrollWidth || 0)) }, (0, HelperUtils_1.getObjectiveLocale)(name)),
            !isLast && (react_1.default.createElement("div", { className: "absolute pt-[4px] h-[20px] left-[36px] bottom-[0px] translate-y-full" },
                react_1.default.createElement(Divider_1.default, { direction: "vertical" }))))));
};
const ProgressTracker = ({ options }) => {
    return (react_1.default.createElement("div", { className: "w-[256px]" }, options.map((value, index) => {
        const isLast = index == options.length - 1;
        return (react_1.default.createElement(ProgressItem, { key: index, iconName: value.iconName, iconText: value.iconText, name: value.name, active: value.active, disabled: value.disabled, onClick: value.onClick, isLast: isLast, dataCy: value.dataCy, isChecked: value?.isChecked }));
    })));
};
exports.default = ProgressTracker;
